import {post} from './httpBase';

//获取订单列表
export function orderList(params) {
    return post('/order/order/list', params)
}
//获取订单详情
export function orderDetail(params) {
    return post('/order/order/detail', params);
}
//获取退票手续费
export function getRefundcharge(params) {
    return post('/order/intercity/refund/charge', params);
}
//退票
export function refund(params) {
    return post('/order/intercity/refund/wx', params);
}
//获取接送站退票手续费
export function refundRuncharge(params) {
    return post('/order/shuttle/refund/charge/wx', params);
}
//接送站退票
export function refundRun(params) {
    return post('/order/shuttle/refund/wx', params);
}
//获取退款详情
export function getRefundInfo(params) {
    return post('/order/intercity/refund/detail', params);
}
//获取改签订单价格接口
export function getChangePic(params) {
    return post('/order/intercity/endorse/charge', params);
}
//改签下单
export function changeSubmit(params) {
    return post('/order/intercity/endorse', params);
}
//订单改签校验接口
export function changeCheck(params) {
    return post('/order/intercity/endorse/check', params);
}

//带货订单列表
export function goodsOrder(params) {
    return post('/order/logistics/listofuser', params);
}
//带货订单详情
export function goodsOrderInfo(params) {
    return post('/order/logistics/details', params);
}
//带货订单退款获取手续费
export function goodsGetcharge(params) {
    return post('/order/logistics/getcharge', params);
}
//带货订单退款
export function goodsOrderCancle(params) {
    return post('/order/logistics/cancle', params);
}



//获取线路积分
export function findPointByLineId(params) {
    return post('/activity/findPointByLineId', params);
}
//查询全部订单
export function allOrderList(params) {
    return post('/order/someorder', params);
}

//创建订单
export function createOrder(params) {
    // return post('/city/create', params)
    return post('/v2/order/create', params)
}

//支付
export function wxPay(params) {
    return post('/pay/wxPay', params)
}

//退票手续费预算
export function refundFee(params) {
    return post('/refund/book', params)
}

//退票申请
export function refundApply(params) {
    // return post('/refund/orderBook', params)
    return post('/v1/refund/refundList', params)
}
export function refundApplySubmit(params) {
    return post('/v1/refund/budget', params)
}
//改签变更信息获取
export function changeDetail(params) {
    return post('/change/exChangeDetail', params)
}

// 改签费用获取
export function changeFee(params) {
    return post('/v1/change/exChangeDetail', params)
}
//司机评价信息
export function estimateInfo(params) {
    return post('/estimate/driverInfo', params)
}
//司机评价
export function estimateAdd(params) {
    return post('/order/invoice/evaluate', params)
}
//获取虚拟电话
export function getPhone(params) {
    return post('/order/phonevirtual/call', params)
}


//包车订单详情
export function busOrderInfo(params) {
    return post('/order/tailoredbusorder/tailoredbusorderdetails', params)
}
//包车取消订单
export function cancelOrder(params) {
    return post('/order/tailoredbusorder/tailoredbusordercancelofuser', params)
}



// WEBPACK FOOTER //
// ./src/service/orderService.js